export const NEWCONTROL = 'NEWCONTROL';
export const DELETECONTROL = 'DELETECONTROL';
export const UPDATECONTROL = 'UPDATECONTROL';
export const CONTROLDATA = 'CONTROLDATA';
export const ONECONTROLDATA = 'ONECONTROLDATA';
export const SHOW_LOADING = 'SHOW_LOADING'